<template>
    <svg :width="width" :height="height" class="stroke-current text-white" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g class="loop">
            <line class="st0" x1="16.7" y1="16.9" x2="21.3" y2="21.6" stroke-miterlimit="10"/>
            <circle class="st0" cx="13.4" cy="13.2" r="4.8" stroke-miterlimit="10"/>
        </g>
    </svg>

</template>

<script>
export default {
    name: "IcSearch",
    props: {
        width: {
            type: Number,
            default: 40
        },
        height: {
            type: Number,
            default: 40
        }
    },

}
</script>

<style scoped>
.loop {
    transition: all 0.5s;
    transform-origin: 50% 20px;
}

svg:hover .loop,
svg:focus .loop,
svg:active .loop {
    transform: rotate(-20deg);
}
</style>
